import React, { useState, Fragment } from "react";
import EditableRow from "./multimedia-component/EditableRow";
import ReadOnlyRow from "./multimedia-component/ReadOnlyRow";
import { nanoid } from "nanoid";
import TextareaAutosize from "react-textarea-autosize";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { catalogTableLabel } from "../../app/helpers/helperCatalogs";
import "./multimedia-component/table-edit-scratch.css"
import PreviewMultimediaVideoModal from "./multimedia-component/PreviewMultimediaVideoModal";
import PreviewMultimediaImageModal from "./multimedia-component/PreviewMultimediaImageModal";
import PreviewMultimediaIframeModal from "./multimedia-component/PreviewMultimediaIframeModal";
import Swal from "sweetalert2";

const initialModuleFile = {
  name: "",
  description: "",
  url: "",
  catalogmultimedias_id: "",
  CatMulti_To_ModFile: "",
}
const NewCatalogRelationMultimedias = ({ tableRecords, setValues, comboData, field, moduleText, occupation, keyRelation}) => {

    const { t } = useTranslation();

  const [addFormData, setAddFormData] = useState({ initialModuleFile });

  const [editFormData, setEditFormData] = useState({ initialModuleFile });
  const [previewFormData, setPreviewFormData] = useState({ initialModuleFile });

  const [editContactId, setEditContactId] = useState(null);
  const [modalVideoIsOpen, setModalVideoIsOpen] = useState(false);
  const [modalIframeIsOpen, setModalIframeIsOpen] = useState(false);
  const [modalImageIsOpen, setModalImageIsOpen] = useState(false);

  const handleChange = (event, idField, type) => {

    if (type === "text") {
      setAddFormData((values) => ({ ...values, [event.target.name]: event.target.value }));
    } else if (type === "relation") {
      if (event != null) {
        
        setAddFormData((values) => ({ ...values, [idField]: event }));
      } else {
        setAddFormData((values) => ({ ...values, [idField]: "" }));
      }
    }

  };

  const handleEditFormChange = (event, idField, type) => {

    if (type === "text") {
      setEditFormData((values) => ({ ...values, [event.target.name]: event.target.value }));
    } else if (type === "relation") {
      if (event != null) {
        
        setEditFormData((values) => ({ ...values, [idField]: event }));
      } else {
        setEditFormData((values) => ({ ...values, [idField]: "" }));
      }
    }

  };

  const handleAddFormSubmit = (event) => {
    event.preventDefault();

    if (addFormData && addFormData.name &&
      addFormData.description &&
      addFormData.url &&
      addFormData.CatMulti_To_ModFile) {

      const newModuleFile = {
        id: nanoid(),
        name: addFormData.name,
        description: addFormData.description,
        url: addFormData.url,

        CatMulti_To_ModFile: addFormData.CatMulti_To_ModFile,

      };

      let newModuleFiles = [];

      if(tableRecords && tableRecords.length > 0) {
        newModuleFiles = [...tableRecords, newModuleFile];
      }else{
        newModuleFiles = [newModuleFile];
      }

      setValues((values) => ({ ...values, [keyRelation]: newModuleFiles }));
      setValues((values) => ({ ...values, catalogmultimedia_list: newModuleFiles }));

      let catalogmultimedia_l = "";
      newModuleFiles.forEach((element, index) => {

        if (index === 0 ){
          catalogmultimedia_l = catalogmultimedia_l.concat(element.name);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.description);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.url);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.CatMulti_To_ModFile.description);
        }else{
          catalogmultimedia_l = catalogmultimedia_l.concat("|");
          catalogmultimedia_l = catalogmultimedia_l.concat(element.name);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.description);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.url);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.CatMulti_To_ModFile.description);
        }

      });

       setValues((values) => ({ ...values, catalogmultimedia_l: catalogmultimedia_l }));

      setAddFormData(initialModuleFile)
    }else{
      Swal.fire(t("titles.error"), t("table_data.validation.data.multimedia"), "warning");
    }

  };

  const handleEditFormSubmit = (event) => {

    event.preventDefault();

    const editedContact = {
      id: editContactId,
      name: editFormData.name,
      description: editFormData.description,
      url: editFormData.url,
      
      CatMulti_To_ModFile: editFormData.CatMulti_To_ModFile,
    };

    const newModuleFiles = [...tableRecords];

    const index = tableRecords.findIndex((tableRecord) => tableRecord.id === editContactId);

    newModuleFiles[index] = editedContact;

    setValues((values) => ({ ...values, [keyRelation]: newModuleFiles }));
    setValues((values) => ({ ...values, catalogmultimedia_list: newModuleFiles }));

    let catalogmultimedia_l = "";
      newModuleFiles.forEach((element, index) => {

        if (index === 0 ){
          catalogmultimedia_l = catalogmultimedia_l.concat(element.name);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.description);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.url);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.CatMulti_To_ModFile.description);
        }else{
          catalogmultimedia_l = catalogmultimedia_l.concat("|");
          catalogmultimedia_l = catalogmultimedia_l.concat(element.name);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.description);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.url);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.CatMulti_To_ModFile.description);
        }

      });

       setValues((values) => ({ ...values, catalogmultimedia_l: catalogmultimedia_l }));

    setEditContactId(null);
  };

  const closeModal = () => {
    setModalImageIsOpen(false);
    setModalVideoIsOpen(false);
    setModalIframeIsOpen(false);

  }

  const handleEditClick = (event, tableRecord) => {
    event.preventDefault();
    setEditContactId(tableRecord.id);

    const formValues = {
      name: tableRecord.name,
      description: tableRecord.description,
      url: tableRecord.url,

      CatMulti_To_ModFile: tableRecord.CatMulti_To_ModFile,
    };

    setEditFormData(formValues);
  };

  const handleCancelClick = () => {
    setEditContactId(null);
  };

  const handleDeleteClick = (contactId) => {
    const newModuleFiles = [...tableRecords];

    const index = tableRecords.findIndex((tableRecord) => tableRecord.id === contactId);

    newModuleFiles.splice(index, 1);

    setValues((values) => ({ ...values, [keyRelation]: newModuleFiles }));
    setValues((values) => ({ ...values, catalogmultimedia_list: newModuleFiles }));

    let catalogmultimedia_l = "";
      newModuleFiles.forEach((element, index) => {

        if (index === 0 ){
          catalogmultimedia_l = catalogmultimedia_l.concat(element.name);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.description);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.url);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.CatMulti_To_ModFile.description);
        }else{
          catalogmultimedia_l = catalogmultimedia_l.concat("|");
          catalogmultimedia_l = catalogmultimedia_l.concat(element.name);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.description);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.url);
          catalogmultimedia_l = catalogmultimedia_l.concat(";",element.CatMulti_To_ModFile.description);
        }

      });

       setValues((values) => ({ ...values, catalogmultimedia_l: catalogmultimedia_l }));
  };

  const handlePreviewMultimediaClick = (contactId) => {
    const newModuleFiles = [...tableRecords];

    let tableRecordSelected = {};

    newModuleFiles.forEach((element) => {
      
      if (element.id === contactId) {
        
        tableRecordSelected = element;
      }

    });

    setPreviewFormData(tableRecordSelected);

    if (tableRecordSelected.CatMulti_To_ModFile.name === "1. Fotografía" ||
      tableRecordSelected.CatMulti_To_ModFile.name === "2. Imagen" ||
      tableRecordSelected.CatMulti_To_ModFile.name === "3. Infografía" ||
      tableRecordSelected.CatMulti_To_ModFile.name === "4. Ilustración"
    ) {
      setModalImageIsOpen(true);
    } else if (tableRecordSelected.CatMulti_To_ModFile.name === "5. Presentación") {
      setModalIframeIsOpen(true);
    } else if (tableRecordSelected.CatMulti_To_ModFile.name === "6. Video") {
      setModalVideoIsOpen(true);
    }

  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      
      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
  };

  return (

    <div className={`col-md-${occupation}`}>
      <label htmlFor={field} className="form-label tit-view">
       {t(`${moduleText}.short.${field}`)}</label>
      <div>
        <div className="app-container-tee">
          <div className="form-tee">
            {/*<form onSubmit={handleEditFormSubmit}>*/}
            <table className="table">
              <thead>
                <tr>
                  <th style={{width:'20%'}}>{t(`${moduleText}.table_multimedias.name`)}</th>
                  <th style={{width:'20%'}}>{t(`${moduleText}.table_multimedias.description`)}</th>
                  <th style={{width:'20%'}}>{t(`${moduleText}.table_multimedias.url`)}</th>
                  <th style={{width:'30%'}}>{t(`${moduleText}.table_multimedias.multimedia_type`)}</th>
                  <th style={{width:'10%'}}>{t(`${moduleText}.table_multimedias.actions`)}</th>
                </tr>
              </thead>
              <tbody>
                {tableRecords && tableRecords.length > 0 &&
                  tableRecords.map((tableRecord) => (
                  <Fragment key={tableRecord.id}>
                    {editContactId === tableRecord.id ? (
                      <EditableRow
                        editFormData={editFormData}
                        handleEditFormChange={handleEditFormChange}
                        handleCancelClick={handleCancelClick}
                        handleEditFormSubmit={handleEditFormSubmit}
                        
                        comboData={comboData}
                        moduleText={moduleText}
                      />
                    ) : (
                      <ReadOnlyRow
                        tableRecord={tableRecord}
                        handleEditClick={handleEditClick}
                        handleDeleteClick={handleDeleteClick}
                        handlePreviewMultimediaClick={handlePreviewMultimediaClick}
                      />
                    )}
                  </Fragment>
                ))}
              </tbody>
            </table>
          </div>
          {/*</form>*/}
           <div className="tit-view-view subtitle-tit">{t(`${moduleText}.table_multimedias.add_multimedia`)}</div>
          {/*<form onSubmit={handleAddFormSubmit}>*/}
          <div className="row g-0">
            <div style={{width:'20%'}}>
              <label htmlFor="name" className="form-label label-information">{t(`${moduleText}.table_multimedias.name`)}</label>
              <TextareaAutosize
                cacheMeasurements
                className="form-control"
                aria-label="empty textarea"
                style={{ width: "100%" }}
                onChange={(event) => handleChange(event, "name", "text")}
                maxRows={5}
                name="name"
                id="name"
                value={addFormData.name}
                required
                maxLength="200"
                placeholder={t(`${moduleText}.table_multimedias.name`)}
              ></TextareaAutosize>
            </div>

            <div style={{width:'20%'}}>
              <label htmlFor="description" className="form-label label-information">{t(`${moduleText}.table_multimedias.description`)}</label>
              <TextareaAutosize
                cacheMeasurements
                className="form-control"
                aria-label="empty textarea"
                style={{ width: "100%" }}
                onChange={(event) => handleChange(event, "description", "text")}
                maxRows={5}
                name="description"
                id="description"
                value={addFormData.description}
                required
                maxLength="400"
                placeholder={t(`${moduleText}.table_multimedias.description`)}
              ></TextareaAutosize>
            </div>
            <div style={{width:'20%'}}>
              <label htmlFor="url" className="form-label label-information">{t(`${moduleText}.table_multimedias.url`)}</label>
              <TextareaAutosize
                cacheMeasurements
                className="form-control"
                aria-label="empty textarea"
                style={{ width: "100%" }}
                onChange={(event) => handleChange(event, "url", "text")}
                maxRows={5}
                name="url"
                id="url"
                value={addFormData.url}
                required
                maxLength="400"
                placeholder={t(`${moduleText}.table_multimedias.url`)}
              ></TextareaAutosize>
            </div>
            <div style={{width:'30%'}}>
              <label htmlFor="CatMulti_To_ModFile" className="form-label label-information">{t(`${moduleText}.table_multimedias.multimedia_type`)}</label>
              <Select
                styles={customStyles}
                
                myFontSize="14px"
                style={{ width: "100%" }}
                onChange={(event) => handleChange(event, "CatMulti_To_ModFile", "relation")}
                
                classNamePrefix="select"
                
                name="CatMulti_To_ModFile"
                
                inputId="CatMulti_To_ModFile"

                value={addFormData.CatMulti_To_ModFile}

                options={comboData}
                getOptionLabel={(option) => catalogTableLabel(option)}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                placeholder={t(`${moduleText}.table_multimedias.multimedia_type`)}
              />
            </div>

            <div style={{width:'10%'}}>
              <label htmlFor="button-add" className="form-label label-information">{t(`${moduleText}.table_multimedias.options`)}</label>
              <button
                id="button-add"
                style={{ width: "80%", height: "54px" }}
                onClick={handleAddFormSubmit}
                className="table-button-preview"
              >
                <i className="fa fa-plus" style={{ fontSize: "48px" }}></i>
              </button>
            </div>

            <PreviewMultimediaVideoModal
              modalVideoIsOpen={modalVideoIsOpen}
              closeModal={closeModal}
              previewFormData={previewFormData}
            />

            <PreviewMultimediaIframeModal
              modalIframeIsOpen={modalIframeIsOpen}
              closeModal={closeModal}
              previewFormData={previewFormData}
            />

            <PreviewMultimediaImageModal
              modalImageIsOpen={modalImageIsOpen}
              closeModal={closeModal}
              previewFormData={previewFormData}
            />

          </div>
          {/*<button type="submit">Add</button>*/}
          {/*</form>*/}
        </div>
      </div>
    </div>

  );
};

export default NewCatalogRelationMultimedias;
